/* eslint-disable */

import axios from 'axios';
import firebase from 'firebase/app';
// import firebase from 'firebase';
import CryptoService from "@/services//crypto-services";
import store from '@/store';
const cryptoService = new CryptoService();
import SentryService from "@/services/sentry-service";
import { GetStaggingOrderPayload } from '@/models/get-stagging-order';
import { UpdateAgentTenantDescPayload } from '@/models/Update-Agent-Tenant-Desc';
import { StagingOrderPayload } from '@/models/stagging-order';
import { AgentType, OrderStatus, StorageKey, WarehouseStaggingStatus } from '@/enums';
import moment from 'moment';
import { RequestAgentCompletedTransactions } from '@/models/Request-Agent-Completed-Transactions';
import { StorageKeys } from '@/constants';
import { DeleteESignReviewRequestsPayload, GetDeliveryLocationPayload, PrintContractPayload } from '@/models';
import { PhysicalCountRequestDT, PhysicalCountResponseDT } from '@/models/PhysicalCountDT'
import * as Sentry from "@sentry/vue";


// const remoteURL = process.env.NODE_ENV === 'production' ? "/actionlistReview" : "http://localhost:51274/";
const environmentForFirebase = 'test';

const remoteURL = process.env.VUE_APP_REMOTE_URL;
// const remoteURL = "https://actionlistctd.greenstonesystems.com/actionlistreview";
//const remoteURL = "http://localhost:51275/";

const configRemoteURL = process.env.VUE_APP_configRemoteURL_URL;
// const configRemoteURL = 'https://configfarmctd.greenstonesystems.com';
// const configRemoteURL ='http://localhost:56632';

const eSignURL = process.env.VUE_APP_ESIGN_RemoteURL;
// const eSignURL = 'https://esignaturectd.greenstonesystems.com';
//const eSignURL = 'http://localhost:60567';

const agenthealthServiceURL = process.env.VUE_APP_AgentHealthService_RemoteURL;
// const agenthealthServiceURL = 'https://gatewayctd.greenstonesystems.com/AgentManagementService';

const agentGateWayUrl = process.env.VUE_APP_GATEWAY_BASE_URL;
// const agentGateWayUrl = "https://gatewayctd.greenstonesystems.com";

const salesRemoteUrl = process.env.VUE_APP_Sales_REMOTEURL;

let agrisSessiontID = "";

import RequestHelperService from '../services/request-helper-service';
import { resolve } from '@sentry/utils';
const requestHelper = new RequestHelperService();

export default class DataService {

    getActionsListRequest(requestType: any, callback: any) {
        var agentInfo = store.getters.getUserInfo;
        let DocumentDate = localStorage.getItem('DocumentDate');
        var data = {
            Status: requestType == "SendContract" ? "1" : "",
            AgentId: agentInfo.AgentId,
            TenantId: agentInfo.TenantId,
            Action: requestType,
            AppName: requestType == "SendContract" ? 'eSignature' : 'myGrower',
            DocumentDate: DocumentDate
        };

        // axios.post(`${remoteURL}/api/ActionListReview/GetReviewRequestsByStatus`, data).then(response => {

        //     response.data.forEach((element: any) => {
        //         try {
        //             if (element.AdditionalInfo) {
        //                 element.AdditionalInfo = JSON.parse(element.AdditionalInfo.replace(new RegExp(`'`, 'g'), '"'));
        //                 element.AdditionalInfo.RequestUser = element.RequestUser;
        //             }
        //         } catch (error) {
        //             SentryService.logMessage(error);
        //             element.AdditionalInfo = {};
        //         }
        //     });
        //     callback(response.data);
        // }).catch(e => {
        //     SentryService.logMessage(e, "getActionsListRequest");
        //     console.log(e);
        // })


        requestHelper.Post(`${remoteURL}/api/ActionListReview/GetReviewRequestsByStatus`, data, undefined, agentInfo.SessionID, agentInfo.TenantId, undefined, undefined, undefined, false, false, false, false)
            .then(response => {
                response.data.forEach((element: any) => {
                    try {
                        if (element.AdditionalInfo) {
                            element.AdditionalInfo = JSON.parse(element.AdditionalInfo.replace(new RegExp(`'`, 'g'), '"'));
                            element.AdditionalInfo.RequestUser = element.RequestUser;
                        }
                    } catch (error) {
                        SentryService.logMessage(error);
                        element.AdditionalInfo = {};
                    }
                });
                callback(response.data);
            }).catch(e => {
                SentryService.logMessage(e, "getActionsListRequest");
                console.log(e);
            })


    }

    getActionsListRequestAsync(requestType: any, callback: any, options: any = null) {
        console.log(requestType);
        var agentInfo = store.getters.getUserInfo;
        let DocumentDate = localStorage.getItem('DocumentDate');
        var data = {
            Status: requestType == "SendContract" ? "1" : "",
            AgentId: agentInfo.AgentId,
            TenantId: agentInfo.TenantId,
            Action: requestType,
            AppName: requestType == "SendContract" ? 'eSignature' : 'myGrower',
            DocumentDate: DocumentDate
        };

        try {
            // let response: any = axios.post(`${remoteURL}/api/ActionListReview/GetReviewRequestsByStatus`, data);
            // if (response && response.Data && response.Data.length) {
            //     response.data.forEach((element: any) => {
            //         try {
            //             if (element.AdditionalInfo) {
            //                 element.AdditionalInfo = JSON.parse(element.AdditionalInfo.replace(new RegExp(`'`, 'g'), '"'));
            //                 element.AdditionalInfo.RequestUser = element.RequestUser;
            //             }
            //         } catch (error) {
            //             SentryService.logMessage(error);
            //             element.AdditionalInfo = {};
            //         }
            //     });

            //     return response;
            // }


            let response: any = requestHelper.Post(`${remoteURL}/api/ActionListReview/GetReviewRequestsByStatus`, data, undefined, agentInfo.SessionID, agentInfo.TenantId, undefined, options, undefined, false, false, false, false)
            if (response && response.Data && response.Data.length) {
                response.data.forEach((element: any) => {
                    try {
                        if (element.AdditionalInfo) {
                            element.AdditionalInfo = JSON.parse(element.AdditionalInfo.replace(new RegExp(`'`, 'g'), '"'));
                            element.AdditionalInfo.RequestUser = element.RequestUser;
                        }
                    } catch (error) {
                        SentryService.logMessage(error);
                        element.AdditionalInfo = {};
                    }
                });

                return response;
            }


        } catch (ex: any) {
            SentryService.logMessage(ex, "getActionsListRequest");
            console.log(ex);
        }
        return [];
    }

    GetESignReviewRequestsByStatus(id: any, callback: any, options: any = null) {
        var agentInfo = store.getters.getUserInfo;
        var data = {
            Status: id,
            AgentId: agentInfo.AgentId,
            TenantId: agentInfo.TenantId,
            Action: "SendContract",
            AppName: 'eSignature',
            DocumentDate: localStorage.getItem('DocumentDate')
        };

        //  axios.post(`${remoteURL}/api/ActionListReview/GetESignReviewRequestsByStatus`, data).then(response => {
        requestHelper.Post(`${remoteURL}/api/ActionListReview/GetESignReviewRequestsByStatus`, data, undefined, agentInfo.SessionID, agentInfo.TenantId, undefined, options, undefined, false, false, false, false)
            .then(response => {
                response.data.forEach((element: any) => {
                    try {
                        if (element.AdditionalInfo && typeof element.AdditionalInfo === 'string') {
                            element.AdditionalInfo = this.fixBrokenJsonString(element.AdditionalInfo);
                        } else if (!element.AdditionalInfo) {
                            element.AdditionalInfo = '{}';
                        }
                    } catch (error) {
                        SentryService.logMessage(error);
                        element.AdditionalInfo = '{}';
                    }
                });
                callback(response.data);
            }).catch(e => {
                if(e.message == "canceled"){
                    return;
                }
                SentryService.logMessage(e, "GetESignReviewRequestsByStatus");
                console.log(e);
            })
    }
    async GetESignReviewRequestsByStatusAsync(id: any, callback: any, options: any = null) {
        var agentInfo = store.getters.getUserInfo;
        var data = {
            Status: id,
            AgentId: agentInfo.AgentId,
            TenantId: agentInfo.TenantId,
            Action: "SendContract",
            AppName: 'eSignature',
            DocumentDate: localStorage.getItem('DocumentDate')
        };
        try {
            //let response: any = await axios.post(`${remoteURL}/api/ActionListReview/GetESignReviewRequestsByStatus`, data);
            let response: any = requestHelper.Post(`${remoteURL}/api/ActionListReview/GetESignReviewRequestsByStatus`, data, undefined, agentInfo.SessionID, agentInfo.TenantId, undefined, options, undefined, false, false, false, false)
            response.data.forEach((element: any) => {
                try {
                    if (element.AdditionalInfo) {
                        element.AdditionalInfo = element.AdditionalInfo.replace(/\u0000/g, '');
                        if (element.AdditionalInfo.toString().includes('""')) {
                            try {
                                element.AdditionalInfo = JSON.parse(element.AdditionalInfo);
                            }
                            catch (err) {
                                try {
                                    element.AdditionalInfo = element.AdditionalInfo.toString().replace(new RegExp(`""`, 'g'), '\\\"');
                                    element.AdditionalInfo = JSON.parse(element.AdditionalInfo);
                                }
                                catch (err2) {

                                }
                            }
                        }
                        else {
                            element.AdditionalInfo = JSON.parse(element.AdditionalInfo.replace(new RegExp(`'`, 'g'), '"'));

                        }
                    }
                } catch (error) {
                    element.AdditionalInfo = {};
                }
            });
            return response.data;
        } catch (ex: any) {
            SentryService.logMessage(ex, "GetESignReviewRequestsByStatus");
            console.log(ex);
        }
    }
    fixBrokenJsonString(badJson: string, debug = false): string {
        try {
            // First, try parsing as-is to validate
            JSON.parse(badJson);
            return badJson; // Return original if it's already valid
        } catch (firstError) {
            if (debug) {
                console.log("👉 Initial parse failed, applying fixes...");
                console.log("👉 Original JSON:", badJson);
            }

            try {
                let cleaned = badJson.trim();

                // Remove null characters that can break JSON parsing
                cleaned = cleaned.replace(/\u0000/g, '');

                // Remove wrapping quotes if present (only if it's a quoted JSON string)
                if (cleaned.startsWith('"') && cleaned.endsWith('"') && !cleaned.startsWith('{"')) {
                    cleaned = cleaned.slice(1, -1);
                    cleaned = cleaned.replace(/\\"/g, '"');
                }

                // Strategy 1: Fix unescaped quotes in property values (precise targeting)
                cleaned = cleaned.replace(
                    /"([^"]+)"\s*:\s*"([^"]*)"([A-Za-z0-9])"(\s*[,}])/g,
                    '"$1" : "$2\\"$3\\"$4'
                );

                // Strategy 2: Fix escaped quotes
                cleaned = cleaned.replace(/\\"/g, '"');

                // Strategy 3: Fix double backslashes
                cleaned = cleaned.replace(/\\\\/g, '\\');

                // Strategy 4: Fix missing commas before closing braces/brackets
                cleaned = cleaned.replace(/"\s*([}\]])/g, '",$1');

                // Strategy 5: Remove trailing commas
                cleaned = cleaned.replace(/,(\s*[}\]])/g, '$1');

                // Strategy 6: Fix unescaped quotes in values (broader pattern)
                cleaned = cleaned.replace(/:\s*"([^"]*)"([^",}\]]*)"([^",}\]]*)/g, ': "$1\\"$2\\"$3"');

                // 1️⃣ Remove wrapping quotes if present (when JSON is inside a string)
                cleaned = cleaned.replace(/^"|"$/g, '');

                // 2️⃣ Escape quotes inside string values (e.g. "COOP FAMILY LLLP "A"" → "COOP FAMILY LLLP \"A\"")
                cleaned = cleaned.replace(/:\s*"([^"]*?)"([^"]*?)"([^"]*?)"/g, (match, p1, p2, p3) => {
                    return `: "${p1}\\"${p2}\\"${p3}"`;
                });

                // 3️⃣ Fix leftover double double-quotes
                cleaned = cleaned.replace(/""/g, '"');

                // 4️⃣ Unescape remaining escaped quotes (only if you know there are extra backslashes)
                cleaned = cleaned.replace(/\\"/g, '"');


                if (debug) {
                    console.log("👉 After all fixes:", cleaned);
                }

                // Validate the fixed JSON
                JSON.parse(cleaned);
                return cleaned;
            } catch (err) {
                if (debug) {
                    console.error("❌ Still invalid after fixes:", err);
                }

                // Last resort: extract key properties and rebuild JSON
                try {
                    const extractValue = (pattern: RegExp) => {
                        const match = badJson.match(pattern);
                        return match ? match[1].replace(/"/g, '') : '';
                    };

                    const extractedData = {
                        AccountID: extractValue(/"AccountID"\s*:\s*"([^"]+)"/),
                        Name: extractValue(/"Name"\s*:\s*"([^"]+)"/),
                        'Document Date': extractValue(/"Document Date"\s*:\s*"([^"]+)"/),
                        'Contract Number': extractValue(/"Contract Number"\s*:\s*"([^"]+)"/),
                        Salesperson: extractValue(/"Salesperson"\s*:\s*"([^"]+)"/),
                        SignerEmail: extractValue(/"SignerEmail"\s*:\s*"([^"]+)"/),
                        SenderEmail: extractValue(/"SenderEmail"\s*:\s*"([^"]+)"/),
                    };

                    return JSON.stringify(extractedData);
                } catch (regexError) {
                    console.warn('All JSON parsing strategies failed:', regexError);
                    return '{}';
                }
            }
        }
    }

    GetESignReviewRequestsCount(): Promise<any> {
        return new Promise((resolve, reject) => {
            var agentInfo = store.getters.getUserInfo;
            var data = {
                AgentId: agentInfo.AgentId,
                TenantId: agentInfo.TenantId,
            };

            // axios.post(`${remoteURL}/api/ActionListReview/GetESignReviewRequestsCount`, data).then(response => {
            //     if (response.data.TransactionObject)
            //         resolve(response.data.TransactionObject);
            //     else {
            //         let error = response.data.ErrorMesage;
            //         console.log(error);
            //         SentryService.logMessage(error, "GetESignReviewRequestsCount");
            //         reject(error);
            //     }
            // }).catch(e => {
            //     console.log(e);
            //     SentryService.logMessage(e, "GetESignReviewRequestsCount");
            // })

            requestHelper.Post(`${remoteURL}/api/ActionListReview/GetESignReviewRequestsCount`, data, undefined, agentInfo.SessionID, agentInfo.TenantId, undefined, undefined, undefined, false, false, false, false)
                .then(response => {
                    if (response.data.TransactionObject)
                        resolve(response.data.TransactionObject);
                    else {
                        let error = response.data.ErrorMesage;
                        console.log(error);
                        SentryService.logMessage(error, "GetESignReviewRequestsCount");
                        reject(error);
                    }
                }).catch(e => {
                    console.log(e);
                    SentryService.logMessage(e, "GetESignReviewRequestsCount");
                })


        })
    }

    getDiscrepanciesForContract(contractName: string, tenantId: string, agentId: string, sessionId: string): Promise<any> {
        return new Promise((resolve, reject) => {
            const data = {
                ContractName: contractName,
                TenantId: tenantId,
                AgentId: agentId,
                SessionId: sessionId
            };

            requestHelper.Post(`${eSignURL}/api/eSign/GetDiscrepanciesForContract`, data, undefined, sessionId, tenantId, undefined, undefined, undefined, false, false, false, false)
                .then(response => {
                    resolve(response.data);
                }).catch(e => {
                    console.log(e);
                    SentryService.logMessage(e, "getDiscrepanciesForContract");
                    reject(e);
                });
        });
    }

    UseCurrentForChangedContract(payload: { TenantId: string, AgentId: string, AppdocumentId: string, UserId: string }): Promise<any> {
        return new Promise((resolve, reject) => {
            requestHelper.Post(`${eSignURL}/api/eSign/UseCurrentForChangedContract`, payload, undefined, undefined, payload.TenantId, undefined, undefined, undefined, false, false, false, false)
                .then(response => {
                    resolve(response.data);
                }).catch(e => {
                    console.log(e);
                    SentryService.logMessage(e, "UseCurrentForChangedContract");
                    reject(e);
                });
        });
    }
    connect(userEmail: any, password: any): Promise<any> {

        var data = {
            AgentEmail: userEmail,
            AgentEncryptedPassword: cryptoService.encryptString(password)
        };

        // Convert to string
        var dataString = JSON.stringify(data);

        // Now you can encrypt dataString
        var encryptedData = { EncryptedData: cryptoService.encryptString(dataString) };



        var promise = new Promise(function (resolve, reject) {

            axios.post(`${remoteURL}/api/ActionListReview/AgentDataSets`, encryptedData).then(response => {
                resolve(response.data);
            }).catch(e => {
                SentryService.logMessage(e, "connect");
                reject(e);
            });
        });

        return promise;
    }

    login(userEmail: any, password: any, sessionID: any, tenantId: any): Promise<any> {
        var data = {
            SessionID: sessionID,
            TenantId: tenantId,
            UserID: userEmail,
            Password: cryptoService.encryptString(password)
        };

        var dataString = JSON.stringify(data);

        // Now you can encrypt dataString
        var encryptedData = { EncryptedData: cryptoService.encryptString(dataString) };



        var promise = new Promise(function (resolve, reject) {
            axios.post(`${remoteURL}/api/ActionListReview/Login`, encryptedData).then((response: any) => {
                // console.log(response.data.isAuthenticated);
                agrisSessiontID = response.data.Message
                // console.log(response.data);
                resolve(response.data);
            }).catch(e => {
                SentryService.logMessage(e, "login");
                reject(e);
            });
        });

        return promise;
    }

    logout(userEmail: any, password: any, sessionID: any, tenantId: any): Promise<any> {
        var data = {
            "SessionID": sessionID,
            "TenantId": tenantId,
            "UserID": userEmail,
            "Password": password,
            "AgrisSessionId": agrisSessiontID
        };

        var promise = new Promise(function (resolve, reject) {
            axios.post(`${remoteURL}/api/ActionListReview/Logout`, data).then(response => {
                resolve(response.data);
            }).catch(e => {
                SentryService.logMessage(e, "logout");
                reject(e);
            });
        });

        return promise;
    }

    getActionsListRequestCount(status: any, agentId: any, tenantId: any, callback: any) {
        return new Promise(function (resolve, reject) {
            var data = {
                Status: status,
                AgentId: agentId,
                TenantId: tenantId
            };
            // axios.post(`${remoteURL}/api/ActionListReview/GetReviewRequestCount`, data).then(response => {
            //     if (response.data.TransactionObject)
            //         resolve(response.data.TransactionObject);
            //     else {
            //         let error = response.data.ErrorMesage;
            //         console.log(error)
            //         SentryService.logMessage(error, "getActionsListRequestCount");
            //         reject(error);
            //     }
            // }).catch(e => {
            //     SentryService.logMessage(e, "getActionsListRequestCount");
            //     reject(e);
            // });



            requestHelper.Post(`${remoteURL}/api/ActionListReview/GetReviewRequestCount`, data, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false)
                .then(response => {
                    if (response.data.TransactionObject)
                        resolve(response.data.TransactionObject);
                    else {
                        let error = response.data.ErrorMesage;
                        console.log(error)
                        SentryService.logMessage(error, "getActionsListRequestCount");
                        reject(error);
                    }
                }).catch(e => {
                    console.log(e);
                    SentryService.logMessage(e, "getActionsListRequestCount");
                    reject(e);
                })
        });
    }

    getModules(): Promise<any> {
        return new Promise(function (resolve, reject) {
            var data = {
                Authorization: 'Basic YWRtaW46cGFzc3dvcmQx',
            };
            axios.get(`${configRemoteURL}/api/Modules `, { headers: data }).then(response => {
                resolve(response.data);
            }).catch(e => {
                SentryService.logMessage(e, "getModules");
                reject(e);
            });
        });
    }
    getConfigurations(moduleId: any, agentId: any, tenantId: any): Promise<any> {
        return new Promise(function (resolve, reject) {
            var data = {
                Authorization: 'Basic YWRtaW46cGFzc3dvcmQx',
            };
            let url = `${configRemoteURL}/api/ModuleConfigurations?ModuleId=${moduleId}`;
            if (agentId) {
                url += `&Agent=${agentId}`;
            }
            if (tenantId) {
                url += `&Dataset=${tenantId}`;
            }
            axios.get(url, { headers: data }).then(response => {
                resolve(response.data);
            }).catch(e => {
                SentryService.logMessage(e, "getConfigurations");
                reject(e);
            });
        });
    }
    saveConfigurations(data: any): Promise<any> {
        return new Promise(function (resolve, reject) {
            axios.post(`${configRemoteURL}/api/ModuleConfigurations`, data, { headers: { Authorization: 'Basic YWRtaW46cGFzc3dvcmQx' } }).then(response => {
                resolve(response.data);
            }).catch(e => {
                SentryService.logMessage(e, "saveConfigurations");
                reject(e);
            });
        });

    }
    doneRequest(requestIds: any, userId: any, message: any, agentSession: any, callback: any, bucketStatus:string = '') {
        var data = {
            ReviewRequestId: requestIds,
            UserId: userId,
            Message: message,
            AgentSession: agentSession,
            ContractStatusCode: bucketStatus.length > 0 ? bucketStatus : undefined
        };

        // axios.post(`${remoteURL}/api/ActionListReview/SetReviewRequestStatusApproved`, data).then(response => {
        //     callback(response.data);
        // }).catch(e => {
        //     console.log(e);
        //     SentryService.logMessage(e, "doneRequest");
        //     callback(false);
        // })

        requestHelper.Post(`${remoteURL}/api/ActionListReview/SetReviewRequestStatusApproved`, data, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false)
            .then(response => {
                callback(response.data);
            }).catch(e => {
                console.log(e);
                SentryService.logMessage(e, "doneRequest");
                callback(false);
            });


    }

    declineRequest(requestId: any, userId: any, message: any, callback: any) {
        var data = {
            ReviewRequestId: [requestId],
            UserId: userId,
            Message: message
        };
        // axios.post(`${remoteURL}/api/ActionListReview/SetReviewRequestStatusRejected`, data).then(response => {
        //     callback(response.data);
        // }).catch(e => {
        //     console.log(e);
        //     SentryService.logMessage(e, "declineRequest");
        //     callback(false);
        // })

        requestHelper.Post(`${remoteURL}/api/ActionListReview/SetReviewRequestStatusRejected`, data, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false)
            .then(response => {
                callback(response.data);
            }).catch(e => {
                console.log(e);
                SentryService.logMessage(e, "declineRequest");
                callback(false);
            })

    }
    cancelRequest(requestIds: any, userId: any, agentSession: any): Promise<any> {
        return new Promise(function (resolve, reject) {
            var data = {
                reviewRequestId: requestIds,
                userId: userId,
                message: "Cancel Request",
                agentSession: agentSession,
            };
            // axios.post(`${remoteURL}/api/ActionListReview/SetReviewRequestStatusCanceled`, data).then(response => {
            //     resolve(response.data);
            // }).catch(e => {
            //     SentryService.logMessage(e, "cancelRequest");
            //     console.log(e);
            //     reject(false);
            // });

            requestHelper.Post(`${remoteURL}/api/ActionListReview/SetReviewRequestStatusCanceled`, data, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false)
                .then(response => {
                    resolve(response.data);
                }).catch(e => {
                    SentryService.logMessage(e, "cancelRequest");
                    console.log(e);
                    reject(false);
                });


        });
    }

    async deleteESignReviewRequests(requestIds: any, agentId: any, tenantId: any, pullAgain = false, trashed = false, isAutoPostContract = false): Promise<any> {
        var agentInfo = store.getters.getUserInfo;
         let userData = JSON.parse(localStorage.getItem("userData") || '{}');

         if(userData){
            agentInfo.Password = userData.Password;
         }


        var data: DeleteESignReviewRequestsPayload = new DeleteESignReviewRequestsPayload();
        var body = {
            AgentId: agentId,
            TenantId: tenantId,
            Action: "SendContract",
            AppName: "eSignature",
            RequestIds: requestIds,
            PullAgain: pullAgain,
            Trashed: trashed,
            IsAutoPostContract: isAutoPostContract,
            Password: agentInfo.Password,
            AgrisSession: agentInfo.AgrisLicense,
            UserID: agentInfo.userEmail
        };
        Object.assign(data, body);

        try {
            if (!agentInfo.Password || agentInfo.Password.length < 1) {
                return false
            }
            let response: any = await requestHelper.Post(`${remoteURL}/api/ActionListReview/DeleteESignReviewRequests`, data, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false);
            if (response && response.data) {
                return response.data;
            }
            else {
                SentryService.logMessage(response.ErrorMesage, "deleteESignReviewRequests");
            }
        } catch (ex: any) {
            SentryService.logError(ex);
        }

        return false;

        // return new Promise((resolve, reject) => {

        //         // axios.post(`${remoteURL}/api/ActionListReview/DeleteESignReviewRequests`, data).then(response => {
        //         //     resolve(response.data);
        //         // }).catch(e => {
        //         //     console.log(e);
        //         //     SentryService.logMessage(e, "deleteESignReviewRequests");
        //         //     reject(false);
        //         // })

        //     requestHelper.Post(`${remoteURL}/api/ActionListReview/DeleteESignReviewRequests`, data, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false)
        //         .then(response => {
        //             resolve(response.data);
        //         }).catch(e => {
        //             SentryService.logMessage(e, "deleteESignReviewRequests");
        //             reject(false);
        //         });
        // });
    }
    async deleteErrorESignReviewRequests(requestIds: any, agentId: any, tenantId: any): Promise<any> {
        // var data = {
        //     AgentId: agentId,
        //     TenantId: tenantId,
        //     EntityIds: requestIds
        // };
        var agentInfo = store.getters.getUserInfo;
        var data: DeleteESignReviewRequestsPayload = new DeleteESignReviewRequestsPayload();
        var body: any = {
            AgentId: agentId,
            TenantId: tenantId,
            EntityIds: requestIds,
            Password: agentInfo.Password,
            AgrisSession: agentInfo.AgrisLicense,
            UserID: agentInfo.userEmail
        };

        Object.assign(data, body);
        // return new Promise((resolve, reject) => {
        //     // axios.post(`${remoteURL}/api/ActionListReview/+`, data).then(response => {
        //     //     resolve(response.data);
        //     // }).catch(e => {
        //     //     console.log(e);
        //     //     SentryService.logMessage(e, "deleteErrorESignReviewRequests");
        //     //     reject(false);
        //     // })

        //     requestHelper.Post(`${remoteURL}/api/ActionListReview/DeleteSyncErrorReviewRequestForEsign`, data, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false)
        //         .then(response => {
        //             resolve(response.data);
        //         }).catch(e => {
        //             console.log(e);
        //             SentryService.logMessage(e, "deleteErrorESignReviewRequests");
        //             reject(false);
        //         })
        // });
        try {
            let response = await requestHelper.Post(`${remoteURL}/api/ActionListReview/DeleteSyncErrorReviewRequestForEsign`, data, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false);
            if (response && response.data) {
                return response.data;
            }
        } catch (e: any) {
            SentryService.logMessage(e, "deleteErrorESignReviewRequests");
        }
        return false;
    }
    deleteESignReviewRequestsBeforeDate(ignoreContactsCreatedBefore_ContractDate: any, agentId: any, tenantId: any): Promise<any> {
        var data = {
            Agent: agentId,
            TenantId: tenantId,
            IgnoreContactsCreatedBefore_ContractDate: ignoreContactsCreatedBefore_ContractDate
        };
        return new Promise((resolve, reject) => {

            // axios.post(`${remoteURL}/api/ActionListReview/DeleteESignReviewRequestsBeforeDate`, data).then(response => {
            //     resolve(response.data);
            // }).catch(e => {
            //     console.log(e);
            //     SentryService.logMessage(e, "deleteESignReviewRequestsBeforeDate");
            //     reject(false);
            // })

            requestHelper.Post(`${remoteURL}/api/ActionListReview/DeleteESignReviewRequestsBeforeDate`, data, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false)
                .then(response => {
                    resolve(response.data);
                }).catch(e => {
                    console.log(e);
                    SentryService.logMessage(e, "deleteESignReviewRequestsBeforeDate");
                    reject(false);
                });


        });
    }
    sendEsignPackageForReminder(requestIds: any): Promise<any> {

        return new Promise((resolve, reject) => {
            // axios.post(`${remoteURL}/api/ActionListReview/ReminderForEsignDocument`, requestIds).then(response => {
            //     resolve(response.data);
            // }).catch(e => {
            //     reject(false);
            //     console.log(e);
            // })

            requestHelper.Post(`${remoteURL}/api/ActionListReview/ReminderForEsignDocument`, requestIds, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false)
                .then(response => {
                    resolve(response.data);
                }).catch(e => {
                    reject(false);
                    console.log(e);
                });

        });
    }
    sendMessage(userId: any, title: any, message: any, requestAgrisNameAddressID: any, requestSQLID: any, requestShipmentDate: any, requestComments: any, requestTicketNumber: any, requestTenantId: any, requestTimestamp: any, requestTicketType: any) {
        var title = title;
        //var body = "<a href='#/portal/grower/scaleticket/'" + requestAgrisNameAddressID + '/' + requestSQLID + ">" + message + "</a>";
        var body = message; // + [requestAgrisNameAddressID] + [requestSQLID];
        //var to = "/topics/" + userId;
        var topic = environmentForFirebase + "_" + userId;
        var to = "/topics/" + topic;

        var notificationInfo = {
            "notification": {
                "title": title,
                "body": body,
                "sound": "default",
                "click_action": "/#/portal/grower/newslist",
                "icon": "fcm_push_icon"
            },
            "data": {
                "param1": "value1",
                "param2": "value2"
            },
            "to": to,
            "priority": "high",
            "restricted_package_name": ""
        }

        var pushNotificationMessage = JSON.stringify(notificationInfo);
        console.log(pushNotificationMessage);
        var xhr = new XMLHttpRequest();
        var url = "https://fcm.googleapis.com/fcm/send";
        xhr.open("POST", url, true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.setRequestHeader("Authorization", "key=AAAAx9mdR5E:APA91bETg3x7jPgsCaNOSJR0XLk6eWvnnht9nJYzVStvy8jN0OMKHO6TVgUSh-yE47g-rAKA0rJi3o0CFJKJCHUelx0ODltKyFkMHCrs6x50ULqwV0W2rXpTNm2v-s9c8fpSr2CtMLzz");
        xhr.send(pushNotificationMessage);

        var data = {
            title: title,
            message: message,
            email: userId,
            agrisNameAddressID: requestAgrisNameAddressID,
            sQLID: 1,
            comments: requestComments,
            shipmentDate: requestShipmentDate,
            ticketNumber: requestTicketNumber,
            tenantId: requestTenantId,
            requestDateTime: requestTimestamp,
            requestTicketType: requestTicketType,
        }

        this.insertDataIntoFirebase(data);
    }

    insertDataIntoFirebase(data: any) {
        var config = {
            apiKey: "AAAAx9mdR5E:APA91bETg3x7jPgsCaNOSJR0XLk6eWvnnht9nJYzVStvy8jN0OMKHO6TVgUSh-yE47g-rAKA0rJi3o0CFJKJCHUelx0ODltKyFkMHCrs6x50ULqwV0W2rXpTNm2v-s9c8fpSr2CtMLzz",
            authDomain: "mygrowermobileclient.firebaseapp.com",
            databaseURL: "https://mygrowermobileclient.firebaseio.com",
            projectId: "mygrowermobileclient",
            storageBucket: "mygrowermobileclient.appspot.com",
        };
        if (!firebase.apps.length) {
            firebase.initializeApp(config);
        }
        var database = firebase.database();
        database.ref('notifications').set({
            title: data.title,
            message: data.message,
            email: data.email,
            showpopup: 'YES',
            agrisNameAddressID: data.agrisNameAddressID,
            sQLID: data.sQLID,
            shipmentDate: data.shipmentDate,
            comments: data.comments,
            ticketNumber: data.ticketNumber,
            CustomerID: data.tenantId,
            requestDateTime: data.requestDateTime,
            requestTicketType: data.requestTicketType
        }, (error) => {
            if (error) {
                console.log(error);
                SentryService.logMessage(error, "insertDataIntoFirebase");
            } else {
                // Data saved successfully!
            }
        });
    }
    getESignContractDownload(reviewrequestId: any, sessionId: any) {
        let url = `${remoteURL}/api/ActionListReview/GetESignContractDownload/${reviewrequestId}/${sessionId}`;
        window.open(url);
    }

    resetEsignCache(agentId: any, tenantId: any): Promise<any> {
        let logMessage = `agentId: ${agentId} tenandId: ${tenantId}`;
        SentryService.logMessage(logMessage, "resetEsignCache");

        var promise = new Promise(function (resolve, reject) {
            // axios.post(`${eSignURL}/api/eSign/RestartContractSyncing/${agentId}/${tenantId}`).then(response => {
            //     console.log(response.data);
            //     resolve(response.data);
            // }).catch(e => {
            //     SentryService.logMessage(e, "connect");
            //     reject(e);
            // });

            requestHelper.Post(`${eSignURL}/api/eSign/RestartContractSyncing/${agentId}/${tenantId}`, undefined, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false)
                .then(response => {
                    console.log(response.data);
                    resolve(response.data);
                }).catch(e => {
                    SentryService.logMessage(e, "connect");
                    reject(e);
                });



        });

        return promise;
    }

    notifyCustomerForStuckContract(doucments: any): Promise<any> {
        var promise = new Promise(function (resolve, reject) {

            // axios.post(`${eSignURL}/api/eSign/NotifyCustomerForStuckContract`, doucments).then(response => {
            //     console.log(response.data);
            //     resolve(response.data);
            // }).catch(e => {
            //     SentryService.logMessage(e, "connect");
            //     reject(e);
            // });

            requestHelper.Post(`${eSignURL}/api/eSign/NotifyCustomerForStuckContract`, doucments, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false)
                .then(response => {
                    console.log(response.data);
                    resolve(response.data);
                }).catch(e => {
                    SentryService.logMessage(e, "connect");
                    reject(e);
                });



        });

        return promise;
    }

    getAgents(): Promise<any> {
        var data = 'grant_type=password&username=apiuser&password=password1';

        var promise = new Promise(function (resolve, reject) {
            let authURL = `${agenthealthServiceURL}/token`;

            axios.post(authURL, data).then(token => {
                if (token.data) {
                    let agentURL = `${agenthealthServiceURL}/api/Agent`;
                    let type = token.data.token_type.charAt(0).toUpperCase() + token.data.token_type.slice(1);
                    let agentData = {
                        Authorization: `${type} ${token.data.access_token}`
                    }
                    axios.get(agentURL, { headers: agentData }).then(response => {
                        resolve(response.data);
                    }).catch(e => {
                        reject(e);
                    });
                }
            }).catch(e => {
                reject(e);
            });
        });

        return promise;
    }

    async getAgrisVersion(): Promise<any> {
        var agentInfo = store.getters.getUserInfo;
        let url = `${agentGateWayUrl}/culturahub/RESTCommandWebService/ExecuteServerCommand/AgentProcessor/GetFilesInfo`;
        let payload = {};
        let headers = {
            SessionID: agentInfo.SessionID,
            TenantID: agentInfo.TenantId
        };

        try {
            let response: any = await requestHelper.postDataToAgentGateway(url, payload, headers);
            if (response && response.status == 200)
                return response.data.Agris.Version;
            return null;

        } catch (ex) {
            return ex;
        }

        // return new Promise((resolve, reject) => {
        //     axios.post(`${agentGateWayUrl}/culturahub/RESTCommandWebService/ExecuteServerCommand/AgentProcessor/GetFilesInfo`, {}, { headers: headers })
        //         .then((response: any) => {
        //             if (response && response.status == 200)
        //                 resolve(response.data.Agris.Version);
        //             else
        //                 reject(null);
        //         }).catch(e => {
        //             reject(e);
        //         });

        // })

    }

    async getAgentType(): Promise<any> {
        var agentInfo = store.getters.getUserInfo;
        let url = `${agentGateWayUrl}/culturahub/RESTCommandWebService/ExecuteServerCommand/AgentProcessor/GetFilesInfo`;
        let payload = {};
        let headers = {
            SessionID: agentInfo.SessionID,
            TenantID: agentInfo.TenantId
        };

        try {
            let response: any = await requestHelper.postDataToAgentGateway(url, payload, headers);
            if (response && response.status == 200) {
                localStorage.setItem(StorageKeys.AgentType, response.data.AgentType);
                return response.data.AgentType;
            }
        } catch (ex) {
            return ex;
        }
        return null;
    }

    async checkAgentOnlineStatus(agentId: string): Promise<boolean> {
        try {
            // First get the bearer token
            const token = await this.getAgentManagementToken();
            if (!token) {
                throw new Error('Failed to obtain authentication token');
            }

            // Then make the agent status check with bearer token
            const url = `${agenthealthServiceURL}/api/DeployedAgent/CheckOnlineStatus/${agentId}`;
            const response = await axios.get(url, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            
            return response.data === true;
        } catch (ex) {
            SentryService.logMessage(ex, "checkAgentOnlineStatus");
            throw ex;
        }
    }

    async getAgentManagementToken(): Promise<string | null> {
        try {
            const url = `${agenthealthServiceURL}/token`;
            
            // Create form data
            const formData = new URLSearchParams();
            formData.append('grant_type', 'password');
            formData.append('username', 'apiuser');
            formData.append('password', 'password1');

            const response = await axios.post(url, formData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });

            if (response.data && response.data.access_token) {
                return response.data.access_token;
            }
            
            return null;
        } catch (ex) {
            SentryService.logMessage(ex, "getAgentManagementToken");
            throw ex;
        }
    }

    async saveStaggingOrders(staggings: StagingOrderPayload[]): Promise<any> {
        return new Promise((resolve: any, reject: any) => {

            var agentInfo = store.getters.getUserInfo;
            let headers = {
                'SessionID': agentInfo.SessionID,
                'TenantID': agentInfo.TenantId,
                'AgentType': agentInfo.AgentType,
            };

            // axios.post(`${remoteURL}/api/WarehouseStagging/InsertUpdateStagging`, staggings, { headers: headers }).then(response => {
            //     resolve(response.data);
            // }).catch(e => {
            //     SentryService.logMessage(e, "connect");
            //     reject(e);
            // });

            requestHelper.Post(`${remoteURL}/api/WarehouseStagging/InsertUpdateStagging`, staggings, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false, headers)
                .then(response => {
                    resolve(response.data);
                }).catch(e => {
                    SentryService.logMessage(e, "connect");
                    reject(e);
                });
        });
    }
    // async saveStaggingOrders(staggings: StagingOrderPayload[]): Promise<any> {
    //     // const promise = await axios(`${remoteURL}/api/WarehouseStagging/InsertUpdateStagging`, { method: "post" });
    //     // if(promise.status == 200){
    //     //     return promise.data;
    //     // }
    //     // return null;

    //     var promise = new Promise(function (resolve, reject) {
    //         axios.post(`${remoteURL}/api/WarehouseStagging/InsertUpdateStagging`, staggings).then(response => {
    //             resolve(response.data);
    //         }).catch(e => {
    //             SentryService.logMessage(e, "connect");
    //             reject(e);
    //         });
    //     });
    //     return promise;
    // }

    deleteStagging(id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            // axios.get(`${remoteURL}/api/WarehouseStagging/DeleteStagging/${id}`).then(response => {
            //     console.log(response.data);
            //     resolve(response.data);
            // }).catch(e => {
            //     SentryService.logMessage(e, "connect");
            //     reject(e);
            // });

            requestHelper.Get(`${remoteURL}/api/WarehouseStagging/DeleteStagging/${id}`, undefined, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false)
                .then(response => {
                    console.log(response.data);
                    resolve(response.data);
                }).catch(e => {
                    SentryService.logMessage(e, "connect");
                    reject(e);
                });

        });
    }

    getStaggings(staggingId: any, inventoryLocations: any = null): Promise<any> {
        let agentInfo = store.getters.getUserInfo;
        let payload = new GetStaggingOrderPayload();
        payload.InventoryLocations = inventoryLocations;
        payload.AgentId = agentInfo.AgentId;
        payload.TenantId = agentInfo.TenantId;
        // payload.StatusId = +WarehouseStaggingStatus.ReadyToStage;
        if (staggingId) {
            payload.StaggingId = staggingId;
        }

        var promise = new Promise((resolve: any, reject: any) => {
            // axios.post(`${remoteURL}/api/WarehouseStagging/GetStaggings`, payload).then(response => {
            //     resolve(response.data);
            // }).catch(e => {
            //     SentryService.logMessage(e, "connect");
            //     reject(e);
            // });

            requestHelper.Post(`${remoteURL}/api/WarehouseStagging/GetStaggings`, payload, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false, {})
                .then(response => {
                    resolve(response.data);
                }).catch(e => {
                    SentryService.logMessage(e, "connect");
                    reject(e);
                });

        });
        return promise;
    }

    getSalesData(requestType: any, transactionType: any): Promise<any> {
        let agentInfo = store.getters.getUserInfo;
        let payload = new GetStaggingOrderPayload();

        payload.AgentId = agentInfo.AgentId;
        payload.TenantId = agentInfo.TenantId;

        // payload.StatusId = +WarehouseStaggingStatus.ReadyToStage;


        var promise = new Promise((resolve: any, reject: any) => {
            requestHelper.Get(`${salesRemoteUrl}/api/Bookings/${requestType}/${agentInfo.AgentId}/${agentInfo.TenantId}/${agentInfo.SessionID}/${agentInfo.userEmail}/false/?transactiontype=${transactionType}`, undefined, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false)
                .then(response => {
                    resolve(response.data);
                }).catch(e => {
                    SentryService.logMessage(e, "connect");
                    reject(e);
                });

        });
        return promise;
    }


    getSalesDataSignatureByBookingId(BookingId: any): Promise<any> {

        var promise = new Promise((resolve: any, reject: any) => {
            requestHelper.Get(`${salesRemoteUrl}/api/Bookings/signatureByBookingId/${BookingId}`, undefined, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false)
                .then(response => {
                    resolve(response.data.TransactionObject);
                }).catch(e => {
                    SentryService.logMessage(e, "getSalesDataSignatureByBookingId");
                    reject(e);
                });
        });
        return promise;
    }


    DownloadprintTransaction(bookingID: string, BookingNumber: string) {


        let pdfLink = `${salesRemoteUrl}/api/Bookings/GetPrintForm?id=${cryptoService.encryptString(String(bookingID))}&isPending=${false}`;
        let encodeURI = encodeURIComponent(pdfLink)


        return new Promise((resolve, reject) => {
            axios.get(decodeURIComponent(encodeURI), {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                'responseType': 'blob' // responseType is a sibling of headers, not a child
            })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', BookingNumber + '.pdf');
                    document.body.appendChild(link);
                    link.click();
                }).catch(e => {
                    console.log(JSON.stringify(e))
                    reject(e);
                })
        });
    }


    getDeliveryPoints(staggingId: any, deliveryLocationId: any): Promise<any> {
        let agentInfo = store.getters.getUserInfo;
        let payload = new GetDeliveryLocationPayload();
        payload.AgentId = agentInfo.AgentId;
        payload.TenantId = agentInfo.TenantId;
        // payload.StatusId = +WarehouseStaggingStatus.ReadyToStage;
        if (staggingId)
            payload.StaggingId = staggingId;

        if (deliveryLocationId)
            payload.DeliveryLocationId = deliveryLocationId;


        var promise = new Promise(function (resolve, reject) {
            // axios.post(`${remoteURL}/api/WarehouseDeliveryLocation/GetDeliveryLocations`, payload).then(response => {
            //     resolve(response.data);
            // }).catch(e => {
            //     SentryService.logMessage(e, "connect");
            //     reject(e);
            // });

            requestHelper.Post(`${remoteURL}/api/WarehouseDeliveryLocation/GetDeliveryLocations`, payload, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false, {})
                .then(response => {
                    resolve(response.data);
                }).catch(e => {
                    SentryService.logMessage(e, "connect");
                    reject(e);
                });

        });
        return promise;
    }

    get AgentInfo() {
        return store.getters.getUserInfo;
    }



    getTenantAgentsDesc(SessionID: any, agentId: any, tenantId: any): Promise<any> {
        let logMessage = `agentId: ${agentId} tenandId: ${tenantId}`;
        //SentryService.logMessage(logMessage, "Getting Agent/Tenant Description From Esign");


        var promise = new Promise(function (resolve, reject) {
            // axios.get(`${configRemoteURL}/api/Modules `, { headers: data }).then(response => {
            //     resolve(response.data);


            // axios.get(`${eSignURL}/api/eSign/GetAgentTenantDescription/${SessionID}/${agentId}/${tenantId}`).then(response => {
            //     console.log(response.data);
            //     resolve(response.data);
            // }).catch(e => {
            //     SentryService.logMessage(e, "connect");
            //     reject(e);
            // });

            requestHelper.Get(`${eSignURL}/api/eSign/GetAgentTenantDescription/${SessionID}/${agentId}/${tenantId}`, undefined, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false)
                .then(response => {
                    // console.log(response.data);
                    resolve(response.data);
                }).catch(e => {
                    SentryService.logMessage(e, "connect");
                    reject(e);
                });

        });

        return promise;
    }


    UpdateTenantAgentsDesc(AgentDesc: any, TenantDesc: any): Promise<any> {
        var agentInfo = store.getters.getUserInfo;
        let SessionID = agentInfo.SessionID;
        let agentId = agentInfo.AgentId;
        let tenantId = agentInfo.TenantId;

        // let logMessage = `agentId: ${agentId}  AgentDesc: ${AgentDesc} tenandId: ${tenantId}  TenantDesc: ${TenantDesc}   `;
        // SentryService.logMessage(logMessage, "Updating Agent/Tenant Description From Esign");

        let payload = new UpdateAgentTenantDescPayload();

        payload.AgentID = agentInfo.AgentId;
        payload.TenantID = agentInfo.TenantId;
        payload.AgentDesc = AgentDesc;
        payload.TenantDesc = TenantDesc;
        payload.agentSession = SessionID;

        var promise = new Promise(function (resolve, reject) {
            // axios.get(`${configRemoteURL}/api/Modules `, { headers: data }).then(response => {
            //     resolve(response.data);

            let ServiceURL = `${eSignURL}/api/eSign/UpdateAgentTenantDescription`;
            // axios.post(ServiceURL, payload).then(response => {
            //     console.log(response.data);
            //     resolve(response.data);
            // }).catch(e => {
            //     SentryService.logMessage(e, "connect");
            //     reject(e);
            // });

            requestHelper.Post(ServiceURL, payload, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false, {})
                .then(response => {
                    // console.log(response.data);
                    resolve(response.data);
                }).catch(e => {
                    SentryService.logMessage(e, "connect");
                    reject(e);
                });
        });

        return promise;
    }


    async GetAgentTenantDetailBytransaction(tenantId: any, StartDate: any, EndDate: any, transactionSuccess: boolean = true): Promise<any> {


        var agentInfo = store.getters.getUserInfo;

        let logMessage = `agentId: ${agentInfo.AgentId} tenandId: ${tenantId}`;
        //SentryService.logMessage(logMessage, "Getting Agent/Tenant Description From Esign");
        let payload = new RequestAgentCompletedTransactions();

        // payload.AgentID = agentInfo.AgentId ? agentInfo.AgentId : null;
        payload.AgentID = null;
        payload.TenantID = tenantId;
        payload.StartDate = StartDate;
        payload.EndDate = EndDate;
        payload.TransactionSuccess = transactionSuccess;


        var promise = new Promise(function (resolve, reject) {

            let ServiceURL = `${eSignURL}/api/eSign/GetCompletedTransactions`;
            //axios.post(ServiceURL, payload).then(response => {
            //     // console.log(response.data);
            //     resolve(response.data);
            // }).catch(e => {
            //     SentryService.logMessage(e, "connect");
            //     reject(e);
            // });

            requestHelper.Post(ServiceURL, payload, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false, {})
                .then(response => {
                    resolve(response.data);
                }).catch(e => {
                    SentryService.logMessage(e, "connect");
                    reject(e);
                });

        });

        return promise;
    }

    getAllTenantByAgentID(agentId: any): Promise<any> {
        let logMessage = `getAllTenantByAgentID  agentId: ${agentId} `;
        SentryService.logMessage(logMessage, "Getting All Tenant Description By AgentID From Esign");


        var promise = new Promise(function (resolve, reject) {

            // axios.get(`${eSignURL}/api/eSign/GetAgentAllTenantDesc/${agentId}`).then(response => {
            //     resolve(response.data);
            // }).catch(e => {
            //     SentryService.logMessage(e, "connect");
            //     reject(e);
            // });

            requestHelper.Get(`${eSignURL}/api/eSign/GetAgentAllTenantDesc/${agentId}`, undefined, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false)
                .then(response => {
                    resolve(response.data);
                }).catch(e => {
                    SentryService.logMessage(e, "connect");
                    reject(e);
                });

        });

        return promise;
    }

    async getAllAgentsDescFromAL(SessionID: any): Promise<any> {
        let logMessage = `SessionID: ${SessionID}`;
        // SentryService.logMessage(logMessage, "Getting get All Agents Desc From Agent Health through Esign");


        var promise = new Promise(function (resolve, reject) {

            // axios.get(`${eSignURL}/api/eSign/GetAllAgentName`).then(response => {
            //     // console.log(response.data);
            //     resolve(response.data);
            // }).catch(e => {
            //     SentryService.logMessage(e, "connect");
            //     reject(e);
            // });


            requestHelper.Get(`${eSignURL}/api/eSign/GetAllAgentName`, undefined, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false)
                .then(response => {
                    // console.log(response.data);
                    resolve(response.data);
                }).catch(e => {
                    SentryService.logMessage(e, "connect");
                    reject(e);
                });

        });

        return promise;
    }

    async getSalesOrdersFromAgris(selectedLocations: any = null, orderNumber: any = null, orderWithNoExpiryIncluded: boolean = true) {
        if (!selectedLocations || selectedLocations.length == 0) {
            return [];
        }

        let locationWhereClause = "";
        for (let index = 0; index < selectedLocations.length; index++) {
            const element = selectedLocations[index];
            locationWhereClause += `<<OrderLines.OrderLocation>> eq '${element.Code}'`;
            locationWhereClause += index < (selectedLocations.length - 1) ? ` or ` : '';
        }

        let agentInfo = store.getters.getUserInfo;

        let orderStatus = 'A';
        let orderType = 'S';
        let orderWithNoExpiry = true;
        let todayDate = moment().format("YYYY-MM-DD");
        let agentType = await this.getAgentType();
        // let agentType = store.getters.getAgentType;
        let params: any[] = [];
        if (locationWhereClause) {
            locationWhereClause = `(${locationWhereClause})`;
            params.push(locationWhereClause);
        }

        params.push(`<<OrderLines.OrderStatus>> eq '${orderStatus}'`);
        params.push(`<<OrderLines.OrderType>> eq '${orderType}'`);

        if (orderNumber)
            params.push(`<<OrderLines.OrderNUmber>> eq '${orderNumber}'`);

        if (orderWithNoExpiry && orderWithNoExpiryIncluded)
            params.push(`(<<OrderLines.ExpirationDate>> > '${todayDate}' or <<OrderLines.ExpirationDate>> contains '1899-12-31')`);
        else { orderWithNoExpiryIncluded ? params.push(`<<OrderLines.ExpirationDate>> > '${todayDate}' `) : ''; }

        if (agentType == AgentType.MSQL)
            params.push(`<<OrderLines.TenantID>> eq '${agentInfo.TenantId.toLowerCase()}'`);

        let url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/OrderLines?where=`;
        params.forEach((param, i) => {
            url = `${url}${(i > 0) ? ' and ' : ''}${param}`
        });

        let headers: any = {
            SessionID: agentInfo.SessionID,
            TenantID: agentInfo.TenantId,
            SelectedEntities: "[OrderLine:OrderRemarks]",
            "Content-Type": "application/json",
        };
        if (agentType == AgentType.MSQL)
            headers.Options = 'CrossTenantQuery|true';

        try {
            let data: any = await requestHelper.getDataFromAgentGateway(url, headers);
            if (data) {
                return data;
            }
        } catch (ex) {
            return ex;
        }

        // const isSessionReferesh = await requestHelper.refreshAgrisLicenseCounter(agentGateWayUrl);
        // if (isSessionReferesh) {
        //     var promise = new Promise(function (resolve, reject) {
        //         let headers: any = {
        //             SessionID: agentInfo.SessionID,
        //             TenantID: agentInfo.TenantId,
        //             SelectedEntities: "[OrderLine:OrderRemarks]",
        //             "Content-Type": "application/json",
        //         };
        //         if (agentType == AgentType.MSQL)
        //             headers.Options = 'CrossTenantQuery|true';

        //         axios.get(url, { headers: headers }).then(response => {
        //             resolve(response.data);
        //         }).catch(async e => {
        //             console.log("message", e.message);
        //             console.log(JSON.stringify(e.response.data.Code));
        //             if (e.response.data.Code == 401) {
        //                 await requestHelper.refreshAgrisLicenseCounter(agentGateWayUrl);
        //             }
        //             reject(e);
        //         });
        //     });
        //     return promise;
        // }
    }

    async getSalesOrderLinesRemarksFromAgris(orderNumber: any = null) {
        try {
            let agentInfo = store.getters.getUserInfo;
            let setupToken = "ORDER_LINE_REM";
            let PackageCode = "INV";
            let agentType = localStorage.getItem(StorageKeys.AgentType);
            if (agentType || agentType == "undefined") {
                let params: any[] = [];

                params.push(`<<PackageSetupToken.SetupToken>> startswith '${setupToken}'`);
                params.push(`<<PackageSetupToken.PackageCode>> eq '${PackageCode}'`);

                if (agentType == AgentType.MSQL)
                    params.push(`<<PackageSetupToken.TenantID>> eq '${agentInfo.TenantId.toLowerCase()}'`);

                let url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/PackageSetupToken?where=`;

                params.forEach((param, i) => {
                    url = `${url}${(i > 0) ? ' and ' : ''}${param}`
                });


                let headers: any = {
                    SessionID: agentInfo.SessionID,
                    TenantID: agentInfo.TenantId,
                    "Content-Type": "application/json",
                };
                if (agentType == AgentType.MSQL) {
                    headers.Options = 'CrossTenantQuery|true';
                }


                return await requestHelper.getDataFromAgentGateway(url, headers);
            }
        } catch (ex) {
            return ex;
        }

        // return new Promise((resolve, reject) => {
        //     let agentInfo = store.getters.getUserInfo;
        //     let setupToken = "ORDER_LINE_REM";
        //     let PackageCode = "INV";
        //     let agentType = localStorage.getItem(StorageKeys.AgentType);
        //     if (agentType || agentType == "undefined") {
        //         let params: any[] = [];

        //         params.push(`<<PackageSetupToken.SetupToken>> startswith '${setupToken}'`);
        //         params.push(`<<PackageSetupToken.PackageCode>> eq '${PackageCode}'`);

        //         if (agentType == AgentType.MSQL)
        //             params.push(`<<PackageSetupToken.TenantID>> eq '${agentInfo.TenantId.toLowerCase()}'`);

        //         let url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/PackageSetupToken?where=`;

        //         params.forEach((param, i) => {
        //             url = `${url}${(i > 0) ? ' and ' : ''}${param}`
        //         });


        //         let headers: any = {
        //             SessionID: agentInfo.SessionID,
        //             TenantID: agentInfo.TenantId,
        //             "Content-Type": "application/json",
        //         };
        //         if (agentType == AgentType.MSQL) {
        //             headers.Options = 'CrossTenantQuery|true';
        //         }
        //         // console.log(url);



        //         axios.get(url, { headers: headers }).then(response => {
        //             resolve(response.data);
        //         }).catch(e => {
        //             reject(e);
        //         });
        //     }
        //     else {
        //         this.getAgentType().then((agentType) => {
        //             localStorage.setItem("AgentType", agentType.AgentType);
        //             resolve(this.getSalesOrderLinesRemarksFromAgris());
        //         })
        //     }

        // });

    }

    async getTransactionsFieldsFromAgris(orderNumber: any = null) {
        try {
            let agentInfo = store.getters.getUserInfo;
            let setupToken = "('TRAN_CODE1_LABEL', 'TRAN_CODE2_LABEL', 'TRAN_CODE3_LABEL', 'TRAN_CODE4_LABEL', 'TRAN_CODE5_LABEL','TRAN_CODE1_REQUIRE','TRAN_CODE2_REQUIRE','TRAN_CODE3_REQUIRE','TRAN_CODE4_REQUIRE','TRAN_CODE5_REQUIRE')";
            let PackageCode = "NAM";
            let agentType = localStorage.getItem(StorageKeys.AgentType);
            if (agentType || agentType == "undefined") {
                let params: any[] = [];

                params.push(`<<PackageSetupToken.SetupToken>> in ${setupToken}`);
                params.push(`<<PackageSetupToken.PackageCode>> eq '${PackageCode}'`);


                if (agentType == AgentType.MSQL)
                    params.push(`<<PackageSetupToken.TenantID>> eq '${agentInfo.TenantId.toLowerCase()}'`);

                let url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/PackageSetupToken?where=`;

                params.forEach((param, i) => {
                    url = `${url}${(i > 0) ? ' and ' : ''}${param}`
                });


                let headers: any = {
                    SessionID: agentInfo.SessionID,
                    TenantID: agentInfo.TenantId,
                    "Content-Type": "application/json",
                };
                if (agentType == AgentType.MSQL) {
                    headers.Options = 'CrossTenantQuery|true';
                }


                return await requestHelper.getDataFromAgentGateway(url, headers);
            }
        } catch (ex) {
            return ex;
        }



    }

    async getLocationsFromAgris(locationCode: any = null) {
        // let agentInfo = store.getters.getUserInfo;
        // let agentType = await this.getAgentType();

        // let params: any[] = [];
        // if (locationCode)
        //     params.push(`<<Locations.Code>> eq '${locationCode}'`);

        // if (agentType == AgentType.MSQL)
        //     params.push(`<<Locations.TenantID>> eq '${agentInfo.TenantId.toLowerCase()}'`);

        // let url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/Locations?where=`;
        // params.forEach((param, i) => {
        //     url = `${url}${(i > 0) ? ' and ' : ''}${param}`
        // });

        // url += "&Properties=Locations:Code,Code,Description";

        // let headers: any = {
        //     SessionID: agentInfo.SessionID,
        //     TenantID: agentInfo.TenantId,
        //     "Content-Type": "application/json",
        // };
        // if (agentType == AgentType.MSQL)
        //     headers.Options = 'CrossTenantQuery|true|Locations.OrderBy|Order By <<Locations.Code>> DESC';
        // else
        //     headers.Options = 'Locations.OrderBy|Order By <<Location.Code>> asc';

        // let response: any = await requestHelper.getDataFromAgentGateway(url, headers);
        // if (response && response.length) {
        //     return response;
        // }
        // return [];


        let agentInfo = store.getters.getUserInfo;
        let agentType = await this.getAgentType();
        var promise = new Promise(function (resolve, reject) {
            let params: any[] = [];
            if (locationCode)
                params.push(`<<Locations.Code>> eq '${locationCode}'`);

            if (agentType == AgentType.MSQL)
                params.push(`<<Locations.TenantID>> eq '${agentInfo.TenantId.toLowerCase()}'`);

            let url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/Locations?where=`;
            params.forEach((param, i) => {
                url = `${url}${(i > 0) ? ' and ' : ''}${param}`
            });

            url += "&Properties=Locations:Code,Code,Description";

            let headers: any = {
                SessionID: agentInfo.SessionID,
                TenantID: agentInfo.TenantId,
                "Content-Type": "application/json",
            };
            if (agentType == AgentType.MSQL)
                headers.Options = 'CrossTenantQuery|true|Locations.OrderBy|Order By <<Locations.Code>> DESC';
            else
                headers.Options = 'Locations.OrderBy|Order By <<Location.Code>> asc';

            console.log(url);
            axios.get(url, { headers: headers }).then(response => {
                resolve(response.data);
            }).catch(e => {
                reject(e);
            });
        });
        return promise;
    }

    async getEmailTypesFromAgris(): Promise<any> {
        let agentTypefromLocal = localStorage.getItem(StorageKeys.AgentType);
        if (agentTypefromLocal || agentTypefromLocal == "undefined") {
            var agentInfo = store.getters.getUserInfo;
            var headers = {
                TenantID: agentInfo.TenantId,
                SessionID: agentInfo.SessionID,
                Options: ''
            };
            let url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/ContactTypes?Where= <<ContactTypes.ContactCategory>> eq ?&param0=E`;
            if (agentTypefromLocal == AgentType.MSQL || agentTypefromLocal == 'undefined' && agentInfo.AgentType == AgentType.MSQL) {
                headers.Options = 'CrossTenantQuery|true';
                url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/ContactType?param1=${agentInfo.TenantId}&Where= <<ContactType.ContactCategory>> eq ? and  <<ContactType.TenantID>> eq ?&param0=E`;
            }
            let response: any = await requestHelper.getDataFromAgentGateway(url, headers);
            if (response && response.length) {
                return response;
            }
            return [];

        }

        // return new Promise((resolve, reject) => {
        //     let agentTypefromLocal = localStorage.getItem(StorageKeys.AgentType);
        //     if (agentTypefromLocal || agentTypefromLocal == "undefined") {
        //         // var agentInfo = JSON.parse(localStorage.agentInfo);
        //         var agentInfo = store.getters.getUserInfo;
        //         var headers = {
        //             TenantID: agentInfo.TenantId,
        //             SessionID: agentInfo.SessionID,
        //             Options: ''
        //         };
        //         let url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/ContactTypes?Where= <<ContactTypes.ContactCategory>> eq ?&param0=E`;
        //         if (agentTypefromLocal == AgentType.MSQL) {
        //             headers.Options = 'CrossTenantQuery|true';
        //             url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/ContactType?param1=${agentInfo.TenantId}&Where= <<ContactType.ContactCategory>> eq ? and  <<ContactType.TenantID>> eq ?&param0=E`;
        //         }

        //         axios.get(url, { headers }).then((response) => {
        //             resolve(response.data);
        //         }, (error) => {
        //             reject(error.error);
        //         })
        //     }
        //     else {
        //         this.getAgentType().then((agentType) => {
        //             localStorage.setItem("AgentType", agentType.AgentType);
        //             resolve(this.getEmailTypesFromAgris());
        //         })
        //     }
        // });
    }

    async getSMSTypesFromAgris(): Promise<any> {
        let agentTypefromLocal = localStorage.getItem(StorageKeys.AgentType);
        if (agentTypefromLocal || agentTypefromLocal == "undefined") {
            var agentInfo = store.getters.getUserInfo;
            var headers = {
                TenantID: agentInfo.TenantId,
                SessionID: agentInfo.SessionID,
                Options: ''
            };
            let url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/ContactTypes?Where= <<ContactTypes.ContactCategory>> eq ?&param0=P`;
            if (agentTypefromLocal == AgentType.MSQL || agentTypefromLocal == 'undefined' && agentInfo.AgentType == AgentType.MSQL) {
                headers.Options = 'CrossTenantQuery|true';
                url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/ContactType?param1=${agentInfo.TenantId}&Where= <<ContactType.ContactCategory>> eq ? and  <<ContactType.TenantID>> eq ?&param0=P`;
            }
            let response: any = await requestHelper.getDataFromAgentGateway(url, headers);
            if (response && response.length) {
                return response;
            }
            return [];
        }
        // return new Promise((resolve, reject) => {
        //     let agentTypefromLocal = localStorage.getItem(StorageKeys.AgentType);
        //     if (agentTypefromLocal || agentTypefromLocal == "undefined") {
        //         var agentInfo = store.getters.getUserInfo;
        //         var headers = {
        //             TenantID: agentInfo.TenantId,
        //             SessionID: agentInfo.SessionID,
        //             Options: ''
        //         };
        //         let url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/ContactTypes?Where= <<ContactTypes.ContactCategory>> eq ?&param0=P`;
        //         if (agentTypefromLocal == AgentType.MSQL) {
        //             headers.Options = 'CrossTenantQuery|true';
        //             url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/ContactType?param1=${agentInfo.TenantId}&Where= <<ContactType.ContactCategory>> eq ? and  <<ContactType.TenantID>> eq ?&param0=C`;
        //         }

        //         axios.get(url, { headers }).then((response) => {
        //             resolve(response.data);
        //         }, (error) => {
        //             reject(error.error);
        //         })
        //     }
        //     else {
        //         this.getAgentType().then((agentType) => {
        //             localStorage.setItem("AgentType", agentType.AgentType);
        //             resolve(this.getSMSTypesFromAgris());
        //         })
        //     }
        // });
        // }
    }

    async getCustomerContactDetailsFromAgris(CustomerId: string, InventoryLocation: string = "100") {

        // let agentTypefromLocal = localStorage.getItem(StorageKeys.AgentType);
        // if (agentTypefromLocal || agentTypefromLocal == "undefined") {
        //     var agentInfo = store.getters.getUserInfo;
        //     var headers: any = {
        //         TenantID: agentInfo.TenantId,
        //         SessionID: agentInfo.SessionID,
        //         "Content-Type": "application/json",
        //     };
        //     let url = `${agentGateWayUrl}/culturahub/RESTCommandWebService/ExecuteServerCommand/CustomerProcessor/GetCustomers?TenantID=${agentInfo.TenantId}&SelectedEntities=[Customer:ContactDetails]&AccountSinceDate=&City=&NameDescription=&NameID=${CustomerId}&PhoneNumber=&TopN=30&InventoryLocation=${InventoryLocation}&NameIdTypeStart=&NameIdTypeEnd=`;
        //     if (agentTypefromLocal == AgentType.MSQL) {
        //         headers.Options = 'CrossTenantQuery|true';
        //         url = `${agentGateWayUrl}/culturahub/RESTCommandWebService/ExecuteServerCommand/CustomerProcessor/GetCustomers?TenantID=${agentInfo.TenantId}&SelectedEntities=[Customer:ContactDetails]&AccountSinceDate=&City=&NameDescription=&NameID=${CustomerId}&PhoneNumber=&TopN=30&InventoryLocation=${InventoryLocation}&NameIdTypeStart=&NameIdTypeEnd=`;
        //     }

        //     let response: any = await requestHelper.postDataToAgentGateway(url, {}, headers);
        //     if (response & response.length) {
        //         return response;
        //     }
        //     return null;
        // }
        // else {
        //     let agentType = await this.getAgentType();
        //     localStorage.setItem("AgentType", agentType.AgentType);
        //     this.getCustomerContactDetailsFromAgris(CustomerId, InventoryLocation);
        // }

        return new Promise((resolve, reject) => {
            let agentTypefromLocal = localStorage.getItem(StorageKeys.AgentType);
            if (agentTypefromLocal || agentTypefromLocal == "undefined") {
                var agentInfo = store.getters.getUserInfo;
                var headers: any = {
                    TenantID: agentInfo.TenantId,
                    SessionID: agentInfo.SessionID,
                    Options: 'TopN|30|NameAddress.OrderBy|Order By <<NameAddress.NameID>> ASC',
                    SelectedEntities: "[NameAddress:ContactDetails]",
                    "Content-Type": "application/json",

                };



                //let url = `${agentGateWayUrl}/culturahub/RESTCommandWebService/ExecuteServerCommand/CustomerProcessor/GetCustomers?TenantID=${agentInfo.TenantId}&SelectedEntities=[Customer:ContactDetails]&AccountSinceDate=&City=&NameDescription=&NameID=${CustomerId}&PhoneNumber=&TopN=30&InventoryLocation=${InventoryLocation}&NameIdTypeStart=&NameIdTypeEnd=`;
                let url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/NameAddress?where=<<NameAddress.NameID>> eq '${CustomerId}'&InventoryLocation=${InventoryLocation}`;
                if (agentTypefromLocal == AgentType.MSQL) {
                    headers.Options = 'CrossTenantQuery|true';
                    // url = `${agentGateWayUrl}/culturahub/RESTCommandWebService/ExecuteServerCommand/CustomerProcessor/GetCustomers?TenantID=${agentInfo.TenantId}&SelectedEntities=[Customer:ContactDetails]&AccountSinceDate=&City=&NameDescription=&NameID=${CustomerId}&PhoneNumber=&TopN=30&InventoryLocation=${InventoryLocation}&NameIdTypeStart=&NameIdTypeEnd=`;
                    url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/NameAddress?where=<<NameAddress.NameID>> eq '${CustomerId}'&TenantID=${agentInfo.TenantId}&InventoryLocation=${InventoryLocation}`;
                }

                axios.get(url, { headers })
                    .then((response) => {
                        resolve(response.data);
                    }, (error) => {
                        reject(error.error);
                    })
            }
            else {
                this.getAgentType().then((agentType) => {
                    localStorage.setItem("AgentType", agentType);
                    resolve(this.getCustomerContactDetailsFromAgris(CustomerId, InventoryLocation));
                })
            }
        });
    }
    async getCustomerContactDetails(CustomerId: string) {
        return new Promise((resolve, reject) => {
            let agentTypefromLocal = localStorage.getItem(StorageKeys.AgentType);

            if (agentTypefromLocal && agentTypefromLocal != "undefined") {
                var agentInfo = store.getters.getUserInfo;
                var headers: any = {
                    AgentType: agentTypefromLocal,
                    TenantID: agentInfo.TenantId,
                    SessionID: agentInfo.SessionID,
                    Options: 'TopN|30|NameAddress.OrderBy|Order By <<NameAddress.NameID>> ASC',
                    SelectedEntities: "[NameAddress:ContactDetails]",
                    "Content-Type": "application/json",

                };
                //let url = `${agentGateWayUrl}/culturahub/RESTCommandWebService/ExecuteServerCommand/CustomerProcessor/GetCustomers?TenantID=${agentInfo.TenantId}&SelectedEntities=[Customer:ContactDetails]&AccountSinceDate=&City=&NameDescription=&NameID=${CustomerId}&PhoneNumber=&TopN=30&InventoryLocation=${InventoryLocation}&NameIdTypeStart=&NameIdTypeEnd=`;
                let url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/NameAddress?where=<<NameAddress.NameID>> eq '${CustomerId}'`;
                if (agentTypefromLocal == AgentType.MSQL) {
                    headers.Options = 'CrossTenantQuery|true';
                    // url = `${agentGateWayUrl}/culturahub/RESTCommandWebService/ExecuteServerCommand/CustomerProcessor/GetCustomers?TenantID=${agentInfo.TenantId}&SelectedEntities=[Customer:ContactDetails]&AccountSinceDate=&City=&NameDescription=&NameID=${CustomerId}&PhoneNumber=&TopN=30&InventoryLocation=${InventoryLocation}&NameIdTypeStart=&NameIdTypeEnd=`;
                    url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/NameAddress?where=<<NameAddress.NameID>> eq '${CustomerId}' and <<NameAddress.TenantID>> eq '${agentInfo.TenantId}'`;
                }

                axios.get(url, { headers })
                    .then((response) => {
                        resolve(response.data);
                    }, (error) => {
                        reject(error.error);
                    })
            }
            else {
                this.getAgentType().then((agentType) => {
                    localStorage.setItem("AgentType", agentType);
                    resolve(this.getCustomerContactDetails(CustomerId));
                })
            }
        });
    }



    async getWarehouseValuesOfLocationFromAgris(InvetoryLocation = 100): Promise<any> {
        return new Promise((resolve, reject) => {
            let agentTypefromLocal = localStorage.getItem(StorageKeys.AgentType);
            if (agentTypefromLocal || agentTypefromLocal == "undefined") {
                var agentInfo = store.getters.getUserInfo;
                var headers = {
                    TenantID: agentInfo.TenantId,
                    SessionID: agentInfo.SessionID,
                    Options: ''
                };
                let url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/InventoryBalances?param0=${InvetoryLocation}&Where= <<InventoryBalances.Location>> eq ? and <<InventoryBalances.Specification13>> <> ''&Properties=InventoryBalance:ItemNumber,Specification13`;
                if (agentTypefromLocal == AgentType.MSQL) {
                    headers.Options = 'CrossTenantQuery|true';
                    url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/InventoryBalances?param0=${agentInfo.TenantId}&param1=${InvetoryLocation}&Where= <<InventoryBalances.TenantID>> eq ? and <<InventoryBalances.Location>> eq ? and <<InventoryBalances.Specification13>> <> ''&Properties=InventoryBalance:ItemNumber,Specification13`;
                }
                axios.get(url, { headers })
                    .then((response) => {

                        resolve(response.data);
                    }, (error) => {
                        if (error.response.data.Code == 404) {
                            resolve([]);
                        } else {
                            reject(error);
                        }
                    });

                // .catch(
                //     function (error) {
                //         console.log("999", error.response.data.Code);
                //     }
                // );

            }
            else {
                this.getAgentType().then((agentType) => {
                    localStorage.setItem("AgentType", agentType.AgentType);
                    resolve(this.getWarehouseValuesOfLocationFromAgris(InvetoryLocation));
                })
            }
        });
    }
    async getWarehouseValuesFromAgris(whereClauseForLocations: any): Promise<any> {
        return new Promise((resolve, reject) => {
            let agentTypefromLocal = localStorage.getItem(StorageKeys.AgentType);
            if (agentTypefromLocal || agentTypefromLocal == "undefined") {
                var agentInfo = store.getters.getUserInfo;
                var headers = {
                    TenantID: agentInfo.TenantId,
                    SessionID: agentInfo.SessionID,
                    Options: ''
                };
                let url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/InventoryBalances?Where= ${whereClauseForLocations} and <<InventoryBalances.Specification13>> <> ''&Properties=InventoryBalance:ItemNumber,Location,Specification13`;
                if (agentTypefromLocal == AgentType.MSQL) {
                    headers.Options = 'CrossTenantQuery|true';
                    // url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/InventoryBalances?param0=${agentInfo.TenantId}&Where= <<InventoryBalances.TenantID>> eq ? and '${whereClauseForLocations}' and <<InventoryBalances.Specification13>> <> ''&Properties=InventoryBalance:ItemNumber,Location,Specification13`;
                    url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/InventoryBalances?Where= <<InventoryBalances.TenantID>> eq ${agentInfo.TenantId} and ${whereClauseForLocations} and <<InventoryBalances.Specification13>> <> ''&Properties=InventoryBalance:ItemNumber,Location,Specification13`;

                }
                axios.get(url, { headers })
                    .then((response) => {
                        resolve(response.data);
                    }, (error) => {
                        if (error.response && error.response.data && error.response.data.Code == 404)
                            resolve([]);
                        else
                            reject(error);

                    });
            }
            else {
                this.getAgentType().then((agentType) => {
                    localStorage.setItem("AgentType", agentType.AgentType);
                    resolve(this.getWarehouseValuesOfLocationFromAgris(whereClauseForLocations));
                })
            }
        });
    }
    async getAllWarehouseValuesOfLocationFromAgris(InvetoryLocation = 100): Promise<any> {
        const isSessionReferesh = await requestHelper.refreshAgrisLicenseCounter();
        if (isSessionReferesh) {
            return new Promise((resolve, reject) => {
                let agentTypefromLocal = localStorage.getItem(StorageKeys.AgentType);
                if (agentTypefromLocal || agentTypefromLocal == "undefined") {
                    var agentInfo = store.getters.getUserInfo;
                    var headers = {
                        TenantID: agentInfo.TenantId,
                        SessionID: agentInfo.SessionID,
                        Options: ''
                    };
                    let url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/InventoryBalances?<<InventoryBalances.Specification13>> <> ''&Properties=InventoryBalance:ItemNumber,Specification13`;
                    if (agentTypefromLocal == AgentType.MSQL) {
                        headers.Options = 'CrossTenantQuery|true';
                        url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/InventoryBalances?param0=${agentInfo.TenantId}&Where= <<InventoryBalances.TenantID>> eq ? and <<InventoryBalances.Specification13>> <> ''&Properties=InventoryBalance:ItemNumber,Specification13`;
                    }

                    axios.get(url, { headers }).then((response) => {
                        resolve(response.data);
                    }, (error) => {
                        reject(error);
                    }
                    )
                }
                else {
                    this.getAgentType().then((agentType) => {
                        localStorage.setItem("AgentType", agentType.AgentType);
                        resolve(this.getWarehouseValuesOfLocationFromAgris(InvetoryLocation));
                    })
                }
            });
        }
    }
    GetTimeZone(): Promise<any> {
        // var data = {};
        return new Promise(async (resolve, reject) => {
            var agentInfo = store.getters.getAgentInfo;

            // axios.get(`${remoteURL}/api/ActionListReview/GetTimezone`).then(response => {
            //     resolve(response.data);
            // }).catch(e => {
            //     console.log(e);
            //     SentryService.logMessage(e, "GetTimezone");
            //     reject(false);
            // })

            await requestHelper.Get(`${remoteURL}/api/ActionListReview/GetTimezone`, undefined, undefined, agentInfo.SessionID, agentInfo.TenantId, undefined, undefined, undefined, false, false, false, false)
                .then(response => {
                    resolve(response.data);
                })
                .catch(e => {
                    console.log(e);
                    SentryService.logMessage(e, "GetTimezone");
                    reject(false);
                });


        });
    }
    async getPhysicalCountDataFromActionsList(PhysicalCountDT: PhysicalCountRequestDT) {
        // Start a transaction for the API request
        const transaction = Sentry.startTransaction({ name: `GetInventoryCount-${PhysicalCountDT.AgentID}-${PhysicalCountDT.TenantID}` });

        // Start a span for the API request (you can name it accordingly)
        const apiCallSpan = transaction.startChild({ op: "http", description: "Post /api/InventoryCount/GetInventoryCount" });

        try {
            let response: any = await requestHelper.Post(`${remoteURL}/api/InventoryCount/GetInventoryCount`, PhysicalCountDT, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false, {});
            if (response && response.data && response.data.TransactionObject) {
                // If the request is successful, finish the span
                apiCallSpan.setStatus("ok"); // Set the status as OK if successful
                apiCallSpan.finish(); // Always call finish() on the span when done
                return response.data.TransactionObject;
            } else {
                let error = response.data.ErrorMesage;
                // Set the span's status as error
                apiCallSpan.setStatus("error");
                apiCallSpan.finish();
                SentryService.logMessage(error, "getPhysicalCountDataFromActionsList");
            }
        }
        catch (ex: any) {
            // Capture the exception in Sentry if an error occurs
            SentryService.logMessage(ex, "getPhysicalCountDataFromActionsList");

            // Set the span's status as error
            apiCallSpan.setStatus("error");
            apiCallSpan.finish();
        } finally {
            // Finish the transaction after the request completes
            transaction.finish();
        }

        return null;


        // return new Promise(function (resolve, reject) {

        // axios.post(`${remoteURL}/api/InventoryCount/GetInventoryCount`, PhysicalCountDT).then(response => {
        //     if (response.data.TransactionObject) {
        //         resolve(response.data.TransactionObject);
        //     }
        //     else {
        //         let error = response.data.ErrorMesage;
        //         console.log(error)
        //         SentryService.logMessage(error, "getPhysicalCountDataFromActionsList");
        //         reject(error);
        //     }
        // }).catch(e => {
        //     SentryService.logMessage(e, "getPhysicalCountDataFromActionsList");
        //     reject(e);
        // });

        // requestHelper.Post(`${remoteURL}/api/InventoryCount/GetInventoryCount`, PhysicalCountDT, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false, {})
        //     .then(response => {
        //         if (response.data.TransactionObject) {
        //             resolve(response.data.TransactionObject);
        //         }
        //         else {
        //             let error = response.data.ErrorMesage;
        //             console.log(error)
        //             SentryService.logMessage(error, "getPhysicalCountDataFromActionsList");
        //             reject(error);
        //         }
        //     }).catch(e => {
        //         SentryService.logMessage(e, "getPhysicalCountDataFromActionsList");
        //         reject(e);
        //     });


        // });
    }
    DeleteInventoryCount(ids: any) {
        return new Promise(function (resolve, reject) {

            // axios.post(`${remoteURL}/api/InventoryCount/DeleteInventoryCount`, ids).then(response => {
            //     if (response.data.TransactionObject) {
            //         resolve(response.data.TransactionObject);
            //     }
            //     else {
            //         let error = response.data.ErrorMesage;
            //         console.log(error)
            //         SentryService.logMessage(error, "DeleteInventoryCount");
            //         reject(error);
            //     }
            // }).catch(e => {
            //     SentryService.logMessage(e, "DeleteInventoryCount");
            //     reject(e);
            // });

            requestHelper.Post(`${remoteURL}/api/InventoryCount/DeleteInventoryCount`, ids, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false, {})
                .then(response => {
                    if (response.data.TransactionObject) {
                        resolve(response.data.TransactionObject);
                    }
                    else {
                        let error = response.data.ErrorMesage;
                        console.log(error)
                        SentryService.logMessage(error, "DeleteInventoryCount");
                        reject(error);
                    }
                }).catch(e => {
                    SentryService.logMessage(e, "DeleteInventoryCount");
                    reject(e);
                });

        });



    }
    getPhysicalCountLocations(PhysicalCountDT: any) {
        return new Promise(function (resolve, reject) {

            // axios.post(`${remoteURL}/api/InventoryCount/GetInventoryCountLocation`, PhysicalCountDT).then(response => {
            //     if (response.data.TransactionObject) {
            //         resolve(response.data.TransactionObject);
            //     }
            //     else {
            //         let error = response.data.ErrorMesage;
            //         console.log(error)
            //         SentryService.logMessage(error, "GetInventoryCountLocation");
            //         reject(error);
            //     }
            // }).catch(e => {
            //     SentryService.logMessage(e, "GetInventoryCountLocation");
            //     reject(e);
            // });

            requestHelper.Post(`${remoteURL}/api/InventoryCount/GetInventoryCountLocation`, PhysicalCountDT, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false, {})
                .then(response => {
                    if (response.data.TransactionObject) {
                        resolve(response.data.TransactionObject);
                    }
                    else {
                        let error = response.data.ErrorMesage;
                        console.log(error)
                        SentryService.logMessage(error, "GetInventoryCountLocation");
                        reject(error);
                    }
                }).catch(e => {
                    SentryService.logMessage(e, "GetInventoryCountLocation");
                    reject(e);
                });


        });
    }
    async getProductCategory(getAll = false): Promise<any> {
        return new Promise((resolve, reject) => {
            let agentTypefromLocal = localStorage.getItem(StorageKeys.AgentType);
            if (agentTypefromLocal || agentTypefromLocal == "undefined") {
                var agentInfo = store.getters.getUserInfo;
                var headers = {
                    TenantID: agentInfo.TenantId,
                    SessionID: agentInfo.SessionID,
                    Options: getAll ? '' : 'TopN|1'
                };
                let url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/ProductCategory`;
                if (agentTypefromLocal == AgentType.MSQL) {
                    headers.Options = 'CrossTenantQuery|true';
                    url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/ProductCategory?Where= <<ProductCategory.TenantID>> eq '${agentInfo.TenantId}'`;

                }
                axios.get(url, { headers })
                    .then((response) => {
                        resolve(response.data);
                    }, (error) => {
                        if (error.response && error.response.data && error.response.data.Code == 404)
                            resolve([]);
                        else
                            reject(error);

                    });
            }
            else {
                this.getAgentType().then((agentType) => {
                    localStorage.setItem("AgentType", agentType.AgentType);
                    resolve(this.getProductCategory());
                })
            }
        });
    }
    async getItemBalance(itemNumber: string, location: string): Promise<any> {
        let agentTypefromLocal = localStorage.getItem(StorageKeys.AgentType);
        if (agentTypefromLocal || agentTypefromLocal == "undefined") {
            return new Promise((resolve, reject) => {
                let agentTypefromLocal = localStorage.getItem(StorageKeys.AgentType);
                if (agentTypefromLocal || agentTypefromLocal == "undefined") {
                    var agentInfo = store.getters.getUserInfo;
                    var headers = {
                        TenantID: agentInfo.TenantId,
                        SessionID: agentInfo.SessionID,
                        Options: ''
                    };
                    let url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/InventoryBalances?Where=<<InventoryBalances.ItemNumber>> eq '${itemNumber}' AND <<InventoryBalance.Location>> eq '${location}'`;
                    if (agentTypefromLocal == AgentType.MSQL) {
                        headers.Options = 'CrossTenantQuery|true';
                        url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/InventoryBalances?Where=<<InventoryBalances.TenantId>> eq '${agentInfo.TenantId}' AND <<InventoryBalances.ItemNumber>> eq '${itemNumber}' AND <<InventoryBalance.Location>> eq '${location}'`;
                    }

                    axios.get(url, { headers }).then((response) => {
                        resolve(response.data);
                    }, (error) => {
                        reject(error);
                    }
                    )
                }
                else {
                    this.getAgentType().then((agentType) => {
                        localStorage.setItem("AgentType", agentType.AgentType);
                        resolve(this.getItemBalance(itemNumber, location));
                    })
                }
            });
        }
    }
    async getUnitsOfMeasureINV(): Promise<any> {
        let agentTypefromLocal = localStorage.getItem(StorageKeys.AgentType);
        if (agentTypefromLocal || agentTypefromLocal == "undefined") {
            return new Promise((resolve, reject) => {
                let agentTypefromLocal = localStorage.getItem(StorageKeys.AgentType);
                if (agentTypefromLocal || agentTypefromLocal == "undefined") {
                    var agentInfo = store.getters.getUserInfo;
                    var headers = {
                        TenantID: agentInfo.TenantId,
                        SessionID: agentInfo.SessionID,
                        Options: ''
                    };
                    let url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/UnitsOfMeasureINV`;
                    if (agentTypefromLocal == AgentType.MSQL) {
                        headers.Options = 'CrossTenantQuery|true';
                        url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/UnitsOfMeasureINV?Where=<<UnitsOfMeasureINV.TenantId>> eq '${agentInfo.TenantId}'`;
                    }

                    axios.get(url, { headers }).then((response) => {
                        resolve(response.data);
                    }, (error) => {
                        reject(error);
                    }
                    )
                }
                else {
                    this.getAgentType().then((agentType) => {
                        localStorage.setItem("AgentType", agentType.AgentType);
                        resolve(this.getUnitsOfMeasureINV());
                    })
                }
            });
        }
    }
    PostInventoryCountToAgris(inventoryCounts: any) {
        return new Promise(function (resolve, reject) {
            var agentInfo = store.getters.getUserInfo;
            let userInfo = store.getters.getUserInfo;
            var body = {
                inventoryCounts: inventoryCounts,
                TenantId: agentInfo.TenantId,
                SessionId: agentInfo.SessionID,
                AgentId: agentInfo.AgentId,
                UserId: userInfo.userEmail,
                Password: userInfo.Password
            }

            requestHelper.Post(`${remoteURL}/api/InventoryCount/PostInventoryCountToAgris`, body, undefined, undefined, undefined, undefined, undefined, undefined, false, false, false, false, {})
                .then(response => {
                    if (response.data.TransactionObject) {
                        resolve(response.data.TransactionObject);
                    }
                    else {
                        resolve(response.data);
                    }
                }).catch(e => {
                    SentryService.logMessage(e, "GetInventoryCountLocation");
                    reject(e);
                });


        });
    }
    getAgeisUserPermissions(userId: any): Promise<any> {
        return new Promise((resolve, reject) => {
            var agentInfo = store.getters.getUserInfo;
            var headers = {
                SessionID: agentInfo.SessionID,
                'Content-Type': 'application/json'
            };
            let url = `${agentGateWayUrl}/culturahub/RESTCommandWebService/ExecuteServerCommand/SecurityProcessor/GetEffectivePermissions?TenantID=${agentInfo.TenantId}&UserID=${userId}&Package=GRN,INV&SecurityOption=COMNU,IVOPT,PIMPT,IVCNT&IgnoreSecurityLevels=true`;
            axios.post(url, { CustomerID: '' }, { headers: headers }).then((permissions) => {
                resolve(permissions.data);
            }).catch(e => {
                reject(e);
            })
        })
    }
    async getItemsFromAgrisByLocation(inventoryLocation: any): Promise<any> {
        const isSessionReferesh = await requestHelper.refreshAgrisLicenseCounter();
        if (isSessionReferesh) {
            return new Promise((resolve, reject) => {
                let agentTypefromLocal = localStorage.getItem(StorageKeys.AgentType);
                if (agentTypefromLocal || agentTypefromLocal == "undefined") {
                    var agentInfo = store.getters.getUserInfo;
                    var headers = {
                        TenantID: agentInfo.TenantId,
                        SessionID: agentInfo.SessionID,
                        Options: ''
                    };
                    let url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/InventoryItem?where=<<InventoryItem.Active>> eq 'Y' and <<InventoryItem.InventoryLocation>> eq '${inventoryLocation}'&Properties=InventoryItem:ItemNumber,ProductCategory,Description,StockingUOM,StockingUOMDV,UseSubitems,ItemNumber`;
                    if (agentTypefromLocal == AgentType.MSQL) {
                        headers.Options = 'CrossTenantQuery|true';
                        url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/InventoryItem?param0=${agentInfo.TenantId}&Where= <<InventoryItem.TenantID>> eq ? and <<InventoryItem.Active>> eq 'Y' and <<InventoryItem.InventoryLocation>> eq '${inventoryLocation}'&Properties=InventoryItem:ItemNumber,ProductCategory,Description,StockingUOM,StockingUOMDV,UseSubitems,ItemNumber `;
                    }

                    axios.get(url, { headers }).then((response) => {
                        resolve(response.data);
                    }, (error) => {
                        reject(error);
                    }
                    )
                }
                else {
                    this.getAgentType().then((agentType) => {
                        localStorage.setItem("AgentType", agentType.AgentType);
                        resolve(this.getItemsFromAgrisByLocation(inventoryLocation));
                    })
                }
            });
        }
    }
    async getMultipleItemBalance(itemNumbers: [], location: string): Promise<any> {
        let agentTypefromLocal = localStorage.getItem(StorageKeys.AgentType);
        if (agentTypefromLocal || agentTypefromLocal == "undefined") {
            return new Promise((resolve, reject) => {
                let agentTypefromLocal = localStorage.getItem(StorageKeys.AgentType);
                if (agentTypefromLocal || agentTypefromLocal == "undefined") {
                    var agentInfo = store.getters.getUserInfo;
                    var headers = {
                        TenantID: agentInfo.TenantId,
                        SessionID: agentInfo.SessionID,
                        Options: ''
                    };
                    let url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/InventoryBalances?Where=<<InventoryBalance.Location>> eq '${location}'`;
                    if (agentTypefromLocal == AgentType.MSQL) {
                        headers.Options = 'CrossTenantQuery|true';
                        url = `${agentGateWayUrl}/culturahub/RESTActivityWebService/agris.relational/InventoryBalances?Where=<<InventoryBalances.TenantId>> eq '${agentInfo.TenantId}' <<InventoryBalance.Location>> eq '${location}'`;
                    }

                    axios.get(url, { headers }).then((response) => {
                        resolve(response.data);
                    }, (error) => {
                        reject(error);
                    }
                    )
                }
                else {
                    this.getAgentType().then((agentType) => {
                        localStorage.setItem("AgentType", agentType.AgentType);
                        resolve(this.getMultipleItemBalance(itemNumbers, location));
                    })
                }
            });
        }
    }
    async SyncInventoryItemsAndBalance(location: any) {
        // Start a transaction for the API request
        const transaction = Sentry.startTransaction({ name: `SyncInventoryItemsAndBalance-${location}` });
        var agentInfo = store.getters.getUserInfo;
        const apiCallSpan = transaction.startChild({ op: "http", description: "GET /api/InventoryItem/SyncInventoryItemsAndBalance" });

        try {
            let response: any = await requestHelper.Get(`${remoteURL}/api/InventoryItem/SyncInventoryItemsAndBalance/${agentInfo.AgentId}/${agentInfo.TenantId}/${location}`, undefined, undefined, agentInfo.SessionID, agentInfo.TenantId, undefined, undefined, undefined, false, false, false, false);
            if (response.data.TransactionObject) {
                // If the request is successful, finish the span
                apiCallSpan.setStatus("ok"); // Set the status as OK if successful
                apiCallSpan.finish(); // Always call finish() on the span when done
                return response.data.TransactionObject;
            } else {
                let error = response.data.ErrorMesage;
                SentryService.logMessage(error, "SyncInventoryItemsAndBalance");
                // Set the span's status as error
                apiCallSpan.setStatus("error");
                apiCallSpan.finish();
            }
        } catch (ex: any) {
            SentryService.logMessage(ex, "SyncInventoryItemsAndBalance");
            // Set the span's status as error
            apiCallSpan.setStatus("error");
            apiCallSpan.finish();
        }
        return null;
        // return new Promise(function (resolve, reject) {
        //     var agentInfo = store.getters.getUserInfo;
        //     requestHelper.Get(`${remoteURL}/api/InventoryItem/SyncInventoryItemsAndBalance/${agentInfo.AgentId}/${agentInfo.TenantId}/${location}`, undefined, undefined, agentInfo.SessionID, agentInfo.TenantId, undefined, undefined, undefined, false, false, false, false)
        //         .then(response => {
        //             if (response.data.TransactionObject)
        //                 resolve(response.data.TransactionObject);
        //             else {
        //                 let error = response.data.ErrorMesage;
        //                 console.log(error)
        //                 SentryService.logMessage(error, "SyncInventoryItemsAndBalance");
        //                 reject(error);
        //             }
        //         }).catch(e => {
        //             console.log(e);
        //             SentryService.logMessage(e, "SyncInventoryItemsAndBalance");
        //             reject(e);
        //         })
        // });
    }
    async GetAgrisItems(location: any, quantityFilters: any, excludedItemNumber: any = []) {
        // Start a transaction for the API request
        const transaction = Sentry.startTransaction({ name: `GetAgrisItems-${quantityFilters}` });

        // Start a span for the API request (you can name it accordingly)
        const apiCallSpan = transaction.startChild({ op: "http", description: `POST /api/InventoryItem/GetAgrisItems/${quantityFilters}` });

        try {
            var agentInfo = store.getters.getUserInfo;
            var data = {
                AgentID: agentInfo.AgentId,
                TenantID: agentInfo.TenantId,
                ExcludedItemNumber: excludedItemNumber.join(","),
                Location: location,
                QuantityFilter: quantityFilters
            };
            let response: any = await requestHelper.Post(`${remoteURL}/api/InventoryItem/GetAgrisItems`, data, undefined, agentInfo.SessionID, agentInfo.TenantId, undefined, undefined, undefined);
            if (response && response.data && response.data.TransactionObject) {
                // If the request is successful, finish the span
                apiCallSpan.setStatus("ok"); // Set the status as OK if successful
                apiCallSpan.finish(); // Always call finish() on the span when done
                return response.data.TransactionObject;
            }
            else {
                let error = response.data.ErrorMesage;
                console.log(error)
                SentryService.logMessage(error, "GetAgrisItems");

                // Set the span's status as error
                apiCallSpan.setStatus("error");
                apiCallSpan.finish();
            }
        }
        catch (ex: any) {
            // Set the span's status as error
            apiCallSpan.setStatus("error");
            apiCallSpan.finish();
            SentryService.logMessage(ex, "GetAgrisItems");
        } finally {
            // Finish the transaction after the request completes
            transaction.finish();
        }

        return null;


        return new Promise(function (resolve, reject) {
            var agentInfo = store.getters.getUserInfo;
            var data = {
                AgentID: agentInfo.AgentId,
                TenantID: agentInfo.TenantId,
                ExcludedItemNumber: excludedItemNumber.join(","),
                Location: location,
                QuantityFilter: quantityFilters
            };

            requestHelper.Post(`${remoteURL}/api/InventoryItem/GetAgrisItems`, data, undefined, agentInfo.SessionID, agentInfo.TenantId, undefined, undefined, undefined)
                .then(response => {
                    if (response.data.TransactionObject)
                        resolve(response.data.TransactionObject);
                    else {
                        let error = response.data.ErrorMesage;
                        console.log(error)
                        SentryService.logMessage(error, "GetAgrisItems");
                        reject(error);
                    }
                }).catch(e => {
                    console.log(e);
                    SentryService.logMessage(e, "GetAgrisItems");
                    reject(e);
                })
        });
    }

    async PrintContract(data: PrintContractPayload) {
        let agentInfo = store.getters.getUserInfo;
        data = {
            Id: 40645,
            AgrisSession: agentInfo.AgrisLicense,
            Password: agentInfo.Password,
            TenantId: agentInfo.TenantId,
            SessionId: agentInfo.SessionID,
            User: agentInfo.userEmail,
            getPDF: false,
            DownloadPDF: false
        };

        try {
            let response: any = await requestHelper.Post(`${remoteURL}/api/BookingsV2/print`, data, undefined, agentInfo.SessionID, agentInfo.TenantId, undefined, undefined, undefined);
            if (response && response.data && response.data.TransactionObject)
                return response.data.TransactionObject;
            else {
                let error = response.data.ErrorMesage;
                SentryService.logMessage(error, "PrintContract");
            }
        }
        catch (ex: any) {
            SentryService.logError(ex);
        }

        return null;

        // return new Promise(function (resolve, reject) {
        //     let agentInfo = store.getters.getUserInfo;
        //     data = {
        //         Id: 40645,
        //         AgrisSession: agentInfo.AgrisLicense,
        //         Password: agentInfo.Password,
        //         TenantId: agentInfo.TenantId,
        //         SessionId: agentInfo.SessionID,
        //         User: agentInfo.userEmail,
        //         getPDF: false,
        //         DownloadPDF: false
        //     };

        //     requestHelper.Post(`${remoteURL}/api/BookingsV2/print`, data, undefined, agentInfo.SessionID, agentInfo.TenantId, undefined, undefined, undefined)
        //         .then(response => {
        //             if (response.data.TransactionObject)
        //                 resolve(response.data.TransactionObject);
        //             else {
        //                 let error = response.data.ErrorMesage;
        //                 console.log(error)
        //                 SentryService.logMessage(error, "GetAgrisItems");
        //                 reject(error);
        //             }
        //         }).catch(e => {
        //             console.log(e);
        //             SentryService.logMessage(e, "GetAgrisItems");
        //             reject(e);
        //         })
        // });

    }


}
